import CONTRATO_GARANTIAS from '@/graphql/querys/administracion/contratos/garantias/contratoGarantias.gql';
import AGREGAR_CONTRATO_GARANTIA from '@/graphql/mutations/administracion/contratos/contrato/garantias/agregarContratoGarantia.gql';
import ACTUALIZAR_CONTRATO_GARANTIA from '@/graphql/mutations/administracion/contratos/contrato/garantias/actualizarContratoGarantia.gql';
import REMOVER_CONTRATO_GARANTIA from '@/graphql/mutations/administracion/contratos/contrato/garantias/removerContratoGarantia.gql';

export default {
  methods: {
    async mixAgregarGarantia() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_GARANTIA,
          variables: {
            garantia: this.garantia,
          },
          update: (store, { data: { agregarContratoGarantia } }) => {
            const query = {
              query: CONTRATO_GARANTIAS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoGarantias } = store.readQuery(query);
            const contratoGarantiasCopia = contratoGarantias.slice();
            contratoGarantiasCopia.push(agregarContratoGarantia);
            store.writeQuery({
              ...query,
              data: {
                contratoGarantias: contratoGarantiasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    async mixActualizarGarantia() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_GARANTIA,
          variables: {
            id: this.garantiaEditar.id,
            garantia: this.garantia,
          },
          update: (store, { data: { actualizarContratoGarantia } }) => {
            const query = {
              query: CONTRATO_GARANTIAS,
              variables: {
                idContrato: this.garantiaEditar.idContrato,
              },
            };
            const { contratoGarantias } = store.readQuery(query);
            const index = contratoGarantias
              .findIndex(({ id }) => id === this.garantiaEditar.id);
            if (index !== -1) {
              contratoGarantias.splice(index, 1, actualizarContratoGarantia);
            }
            store.writeQuery({
              ...query,
              data: {
                contratoGarantias,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    async mixEliminarGarantia() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_GARANTIA,
        variables: {
          id: this.garantiaEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_GARANTIAS,
            variables: {
              idContrato: this.garantiaEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoGarantias } = data;
          const index = contratoGarantias
            .findIndex(({ id }) => id === this.garantiaEliminar.id);
          if (index !== -1) {
            contratoGarantias.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
